var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBars = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 18,
  viewBox: "0 0 20 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 0H4V8H6V10H4V15H2V7H0V5H2V0ZM9 3H11V6H13V8H11V18H9V15H7V13H9V3ZM16 2H14V4H16V15H18V13H20V11H18V0H16V2Z",
  fill: "#7F7F7F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBars);
export { ForwardRef as ReactComponent };